const operatorId = "zain_iraq"
const elasticPublishUrl = "https://serviceusagesv1.bngrenew.com/publish"



export {
    operatorId,
    elasticPublishUrl
}